export function dateFormat(dateString, suffix = "") {
  const date = new Date(dateString);
  const now = new Date();
  const diffInMs = now - date;
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));

  if (diffInMinutes <= 0) {
    return 'Just now';
  }

  if (diffInMinutes < 60) {
    return `${diffInMinutes}m${suffix}`;
  }

  if (diffInHours < 24) {
    return `${diffInHours}h${suffix}`;
  }

  if (date.getFullYear() === now.getFullYear()) {
    return date.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
  }

  return date.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
}

export function prettifyDate(dateString, withTime = true) {
  const date = new Date(dateString);
  const timeFormat = withTime ? {hour: '2-digit', minute: '2-digit'} : {};
  return date.toLocaleDateString(undefined, { ...timeFormat, day: 'numeric', month: 'short', year: 'numeric' });
}

export function prettifyNumbers(num) {
  if (num < 1000) return num.toString();
  if (num < 1_000_000) return (num / 1000).toFixed(num % 1000 >= 100 ? 1 : 0) + "k";
  if (num < 1_000_000_000) return (num / 1_000_000).toFixed(1) + "M";
  return (num / 1_000_000_000).toFixed(1) + "B";
}
